// extracted by mini-css-extract-plugin
module.exports = {"FormTitle":"ImpactedMember_FormTitle_3IOhJ","copy_button":"ImpactedMember_copy_button_2VwAX","box":"ImpactedMember_box_2rqwQ"};